/** @format */
import { useEffect, useRef, useState } from 'react';

import { getCsrfToken } from '@toucan/client/global/application';

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
interface UseCsrfResponse {
    csrfToken: string;
    refreshCsrf: () => Promise<string>;
}

export function useCsrf(): UseCsrfResponse {
    const [csrfToken, setCsrfToken] = useState<string>('');
    const isCancelled = useRef(false);

    async function getAndSetToken() {
        try {
            const response = await getCsrfToken();

            if (!isCancelled.current) {
                const token = response?.data?.csrfToken ?? '';
                setCsrfToken(token);
                return token;
            }

            return '';
        } catch {
            return '';
        }
    }

    useEffect(() => {
        getAndSetToken();

        return () => {
            isCancelled.current = true;
        };
    }, []);

    return {
        csrfToken,
        refreshCsrf: getAndSetToken,
    };
}
